import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/modal.actions';
import {
	getDiscountTypes,
	getAccountServicelines,
	createDiscount,
	updateDiscount,
	emptyAccountServicelines,
	emptyDiscountsTypes
} from '../../../actions/accountDetailsActions/billing.actions';
import { getAccountDetails, getUser, getModalData } from '../../../selectors';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {toastr} from "react-redux-toastr";

const DiscountSchema = Yup.object().shape(
	{
		applyOn: Yup.string().required('Required'),
		amount: Yup.number().typeError('Only digits').positive('Only positive amounts').required('Required'),
		itemId: Yup.string().required('Required'),
		note: Yup.string('Must be string').min(10, 'Minimum 10 character').required('Required')
	}
);

class AddDiscountModal extends Component {
	state = {
		showAlertMessage: false,
		alertMessage: ''
	};

	componentDidMount() {
		this.props.getDiscountTypes(this.props.accountTypeId, this.props.currentLocationId);
		this.props.getAccountServicelines(this.props.accountId);
	}

	componentWillUnmount() {
		this.props.emptyDiscountsTypes();
		this.props.emptyAccountServicelines();
	}

	onHandleChangeApplyOn = (e) => {
		this.setState({
			applyOn: e.target.value
		});
	};

	formatedLabel = (values) => {
		const { discountTypesData } = this.props;

		let discountType = discountTypesData.find((discount) => discount.id === Number(values.itemId));

		if (discountType && discountType.type === 'CREDIT') {
			return 'Credit Amount';
		} else {
			return 'Amount';
		}
	};

	showCreditDiscountType = () => {
		if(this.props.modalProps.row && this.props.modalProps.row.itemType === 'CREDIT'){
			return true;
		}
		return false;
	}

	showChargeDiscountType = () => {
		if(this.props.modalProps.row && this.props.modalProps.row.itemType === 'ADJ-CHARGES'){
			return true;
		}
		return false;
	}

	sortArray = (property) => {
		return function(a, b) {

			if (a[property] < b[property]) {
				return -1;
			}
			else if (a[property] > b[property]) {
				return 1;
			}
			else {
				return 0;
			}
		}
	}

	formSubmit = (values, actions) => {
		if (this.props.modalProps.type === 'create') {
			this.props.createDiscount(this.props.accountId, values).then((response) => {
				if (response.data.success) {
					toastr.success(response.data.message, { timeOut: 1000, position: 'top-center' });
					this.closeModal();
				} else {
					const errorMessage = response.error.code + ":" + response.error.message;
					toastr.error(errorMessage, {timeOut: 0, position: 'top-center'});
					actions.setSubmitting(false);
					this.setState({
						showAlertMessage: true,
						alertMessage: response.data.error && response.data.error.message
					});
				}
			});
		} else {
			const { accountId, modalProps } = this.props;

			const data = {
				amount: Math.abs(values.amount)
			};

			this.props.updateDiscount(accountId, modalProps.row.id, data).then((response) => {
				if(response.data.success) {
					toastr.success(response.data.message, { timeOut: 1000, position: 'top-center' });
					this.props.hideModal();
				} else {
					let errorMessage = response.data.error.code + ":" + response.data.error.message;
					toastr.error(errorMessage, {timeOut: 0, position: 'top-center'});
					actions.setSubmitting(false);
				}
			});
		}
	};

	closeModal = () => {
		this.props.hideModal();

		if (this.props.modalProps.onCloseCallback) {
			this.props.modalProps.onCloseCallback();
		}
	};

	render() {
		const { showAlertMessage, alertMessage } = this.state;
		const { modalProps, discountTypesData, discountServicelinesData } = this.props;

		discountTypesData.sort(this.sortArray("description"));

		let showCredit = this.showCreditDiscountType();
		let showCharge = this.showChargeDiscountType();

		return (
			<Fragment>
				<div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
					<Formik
						initialValues={{
							discountType: (modalProps.type === 'create'
								? 'CREDIT'
								: (modalProps.row && modalProps.row.itemType === 'CREDIT')
									? 'CREDIT'
									: 'ADJ-CHARGES'
							),
							amount: (modalProps.row && Math.abs(modalProps.row.amount)) || 0,
							itemId: (modalProps.row && modalProps.row.itemId) || '',
							locationId: this.props.currentLocationId,
							note: (modalProps.row && modalProps.row.note) || '',
							serviceLineId: (modalProps.row && modalProps.row.serviceLineId) || '',
							applyOn: this.props.modalProps.applyOnPeriod || 'immediately'
						}}
						validationSchema={DiscountSchema}
						onSubmit={this.formSubmit}
						render={({ setFieldValue, handleChange, handleSubmit, handleBlur, values, errors, touched, isSubmitting }) => (
							<form onSubmit={handleSubmit}>
								<div className="modal-dialog">
									<div className="modal-content">
										<div className="modal-header">
											<h5 className="modal-title">
												{modalProps.type === 'create' ? 'Add' : 'Edit'} Pending Discount
											</h5>
											<button onClick={this.props.hideModal} type="button" className="close">
												<span aria-hidden="true">&times;</span>
											</button>
										</div>
										<div className="modal-body form-horizontal">

											{showAlertMessage === true && (
												<div className="alert alert-inline alert-danger alert-dismissible">
													<p className="mb-0">{alertMessage}</p>
												</div>
											)}

											<div className="form-group d-flex justify-content-end">
												{(showCredit || (!showCredit && !showCharge)) &&
												<span className="h-check">
													<div className="form-check checkbox-slider checkbox-slider--b-flat">
														<label>
															<input
																name="discountType"
																type="radio"
																onChange={() => {
																	setFieldValue('itemId', '');
																	setFieldValue('discountType', 'CREDIT');
																	touched.itemId = false;
																}}
																checked={values.discountType === 'CREDIT'}
																disabled={modalProps.type === 'edit'}
															/>
															<span className="ml-2">Credit</span>
														</label>
													</div>
												</span>
												}
												{(showCharge || (!showCredit && !showCharge)) &&
												<span className="h-check ml-4">
													<div className="form-check checkbox-slider checkbox-slider--b-flat">
														<label>
															<input
																name="discountType"
																type="radio"
																onChange={() => {
																	setFieldValue('itemId', '');
																	setFieldValue('discountType', 'ADJ-CHARGES');
																	touched.itemId = false;
																}}
																checked={values.discountType === 'ADJ-CHARGES'}
																disabled={modalProps.type === 'edit'}
															/>
															<span className="ml-2">Charge</span>
														</label>
													</div>
												</span>
												}
											</div>

											<div className="form-group">
												<label>Discount Type</label>
												<select
													className={'form-control customer-discount-type' + (errors.itemId && touched.itemId ? ' is-invalid': '')}
													name="itemId"
													placeholder="Please select discount"
													value={values.itemId}
													onChange={handleChange}
													onBlur={handleBlur}
													disabled={modalProps.type === 'edit'}
												>
													<option value="itemId">Please select Item</option>
													{discountTypesData.map((type) => (
														((values.discountType === '' || type.type === values.discountType) &&
														<option value={type.id.toString()} key={type.id}>
															{type.description}
														</option>
														)
													))}
												</select>
												{errors.itemId &&
												touched.itemId && (
													<div className="invalid-feedback">{errors.itemId}</div>
												)}
											</div>
											<div className="form-group">
												<label>Serviceline (Optional)</label>
												<select
													className={
														errors.serviceLineId && touched.serviceLineId ? (
															'form-control customer-discount-serviceline is-invalid'
														) : (
															'form-control customer-discount-serviceline'
														)
													}
													placeholder="Please select serviceline"
													value={values.serviceLineId}
													onChange={handleChange}
													onBlur={handleBlur}
													name="serviceLineId"
													disabled={modalProps.type === 'edit'}
												>
													<option value="">Please select serviceline</option>
													{discountServicelinesData.map((serviceline) => (
														<option value={serviceline.id} key={serviceline.id}>
															{serviceline.number}
														</option>
													))}
												</select>
											</div>

											<div className="form-group">
												<label>{this.formatedLabel(values)}</label>
												<div className="input-group">
													<div className="input-group-prepend">
														<div className="input-group-text">$</div>
													</div>
													<input
														type="text"
														className={
															errors.amount && touched.amount ? (
																'form-control is-invalid'
															) : (
																'form-control'
															)
														}
														placeholder="Amount"
														value={values.amount}
														onChange={handleChange}
														onBlur={handleBlur}
														name="amount"
													/>
													{errors.amount &&
													touched.amount && (
														<div className="invalid-feedback">{errors.amount}</div>
													)}
												</div>
												<p><small class="text-muted">Will be applied on the next bill run.</small></p>
											</div>
											<div className="form-group">
												<label>Note</label>
												<textarea
													className={
														errors.note && touched.note ? (
															'form-control is-invalid'
														) : (
															'form-control'
														)
													}
													value={values.note}
													onChange={handleChange}
													onBlur={handleBlur}
													name="note"
													disabled={modalProps.type === 'edit'}
												/>
												{errors.note &&
												touched.note && <div className="invalid-feedback">{errors.note}</div>}
											</div>
										</div>
										<div className="modal-footer">
											<button onClick={this.props.hideModal} className="btn" type="button">
												Cancel
											</button>
											<button disabled={isSubmitting} type="submit" className="btn btn-primary">
												{modalProps.type === 'create' ? 'Add Discount' : 'Edit Discount'}
											</button>
										</div>
									</div>
								</div>
							</form>
						)}
					/>
				</div>
				<div className="modal-backdrop show" tabIndex="1" />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	const discountTypesData = getAccountDetails(state).billing.discountTypes,
		discountServicelinesData = getAccountDetails(state).billing.accountServicelines,
		currentLocationId = getUser(state).currentLocation.id,
		accountTypeId = getAccountDetails(state).accountDetails.accountInfo.accountType.id,
		accountId = getAccountDetails(state).accountDetails.accountInfo.id,
		modalProps = getModalData(state).modalProps;

	return {
		discountTypesData,
		discountServicelinesData,
		currentLocationId,
		accountTypeId,
		accountId,
		modalProps
	};
};

const mapDispatchToProps = {
	getDiscountTypes,
	getAccountServicelines,
	createDiscount,
	updateDiscount,
	hideModal,
	emptyAccountServicelines,
	emptyDiscountsTypes
};

export default connect(mapStateToProps, mapDispatchToProps)(AddDiscountModal);